import { render, staticRenderFns } from "./CancelledOrdersRatio.vue?vue&type=template&id=4ef9a831&scoped=true"
import script from "./CancelledOrdersRatio.vue?vue&type=script&lang=js"
export * from "./CancelledOrdersRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef9a831",
  null
  
)

export default component.exports